// Appointment type colors, shared by the Planner calendar, dialog, and dashboard widget.
export const APPT_KINDS = {
  call: { label: "Call", color: "#0ea5e9" },
  meeting: { label: "Meeting", color: "#8b5cf6" },
  followup: { label: "Follow-up", color: "#f59e0b" },
  other: { label: "Other", color: "#64748b" },
};
